module.exports = __webpack_public_path__ + "img/161.7648c7ee.jpg";